import { useIntl } from "react-intl";
import RpisPage from "../../containers/RpisPage/RpisPage";
import { LDExportStatisticsContainer } from "./LDExportStatisticsContainer";
import Messages from "../../localization/Messages";
import "./LDExportStatistics.css";

export const LDExportStatistics = () => {
    const intl = useIntl();

    return (
        <RpisPage
            className="ld-export-statistics-page"
            title={intl.formatMessage(Messages.exportStatistics)}
        >
            <LDExportStatisticsContainer />
        </RpisPage>
    );
};

export default LDExportStatistics;
